import { assertInInjectionContext, computed, DestroyRef, effect, inject, Injectable } from '@angular/core';
import { ConfigurationService } from 'libs/core/src/lib/services/configuration.service';
import { UserService } from 'libs/core/src/lib/services/user.service';
import { SnackbarService } from '../snackbar/snackbar.service';

/** Top banner for a player whose Shopping Dollar balance is $0 (US-01.2 AC04), shown on home, cart and checkout. */
@Injectable({
  providedIn: 'root',
})
export class ZeroBalanceNoticeService {
  private readonly userService = inject(UserService);
  private readonly rewardName = inject(ConfigurationService).rewardName;
  private readonly snackbarService = inject(SnackbarService);

  // Wait for the reward name too, so the sentence never shows with a gap.
  private readonly isZeroBalance = computed(
    () => !!this.userService.user() && this.userService.points() === 0 && !!this.rewardName(),
  );

  /** Keeps the banner up while the calling page is open. Call it from a component constructor. */
  showWhilePageIsOpen(): void {
    assertInInjectionContext(this.showWhilePageIsOpen);
    let bannerId: number | undefined;

    const dismiss = () => {
      if (bannerId === undefined) return;
      this.snackbarService.dismiss(bannerId);
      bannerId = undefined;
    };

    effect(() => {
      if (this.isZeroBalance()) {
        bannerId = this.snackbarService.info(
          '',
          `No ${this.rewardName()} are available for your account. You can still buy by card.`,
          { sticky: true, dismissible: true },
        );
      } else {
        dismiss();
      }
    });

    inject(DestroyRef).onDestroy(dismiss);
  }
}
